// @ts-nocheck
import { actionableStyles } from './reportingActionablesStyles';

export const reportingHeaderActuator = async (action: 'show' | 'hide'): Promise<void> => {
  const headerButton = document.getElementsByClassName('actionButton__button')[0] as HTMLButtonElement;
  if (headerButton) {
    const isHeaderExpanded = headerButton.children[0].className.includes('fa-minus');
    if ((action === 'show' && !isHeaderExpanded) || (action === 'hide' && isHeaderExpanded)) {
      headerButton.click();
      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, 0);
      });
    }
  }
};

export const stylesForActionableItems = (action: 'add' | 'remove'): void => {
  const elementStyleId = 'actionableItemsCustomStyles';
  const styleSection = document.getElementById(elementStyleId);
  if (action === 'add' && !styleSection) {
    const style = document.createElement('style');
    style.id = elementStyleId;
    style.textContent = actionableStyles;
    document.head.appendChild(style);
  }
  if (action === 'remove' && styleSection) {
    styleSection.remove();
  }
};

export const selectedMetricToMapTotals = (action: 'add' | 'hide'): void => {
  const maps = document.querySelectorAll('.mapContainer__mapsContainer');
  for (let i = 0; i < maps.length; i++) {
    const metricSelector = '.singleSelectorComponent__control .singleSelectorComponent__single-value';
    const totalSelector = '.insightsRankingItem__ranks .rankingItem .rankingItem__leftContainer .rankingItem__label';
    const selectedMetricElement = maps[i].querySelector(metricSelector);
    const totalElement = maps[i].querySelector(totalSelector);
    if (!selectedMetricElement || !totalElement) {
      return;
    }
    const selectedMetric = selectedMetricElement.innerHTML;
    if (action === 'add') {
      totalElement.innerHTML = `${totalElement.innerHTML} - ${selectedMetric}`;
    } else {
      totalElement.innerHTML = totalElement.innerHTML.replace(` - ${selectedMetric}`, '');
    }
  }
};
